import { GIFTS, type Gift } from "@app/protocol";
import { useT } from "../i18n/context";

/**
 * The table part of a seat's card (review 0022): gifts to send, and for someone else, hiding their
 * reactions and gifts for this session (decision 143).
 */
export function CardSocial({
  self,
  muted,
  onGift,
  onMute,
}: {
  self: boolean;
  muted: boolean;
  onGift: (gift: Gift) => void;
  onMute: () => void;
}) {
  const { t } = useT();
  return (
    <div className="mt-3 flex flex-col gap-2 border-t border-ink/10 pt-3">
      <span className="text-[11px] font-bold uppercase tracking-[0.08em] text-ink/60">
        {t("gift.send")}
      </span>
      <div className="grid grid-cols-5 gap-1">
        {GIFTS.map((gift) => (
          <button
            key={gift}
            type="button"
            aria-label={t(`gift.${gift}`)}
            title={t(`gift.${gift}`)}
            className="flex aspect-square items-center justify-center rounded-[10px] bg-ink/6 p-1 hover:bg-ink/14"
            onClick={() => onGift(gift)}
          >
            <img
              src={`/gifts/${gift}.webp`}
              alt=""
              draggable={false}
              className="h-full w-full object-contain"
            />
          </button>
        ))}
      </div>
      {self ? null : (
        <button
          type="button"
          aria-pressed={muted}
          className="h-10 rounded-pill border-[1.5px] border-ink/25 text-[13px] font-bold text-ink/85 hover:bg-ink/10"
          onClick={onMute}
        >
          {t(muted ? "social.unmute" : "social.mute")}
        </button>
      )}
    </div>
  );
}
